import { ROUTES } from '@/lib/routes';

export type DashboardHeaderConfig = {
  title: string;
  subtitle?: string;
  actionsVariant: 'dashboard' | 'projects' | 'sources' | 'none';
};

export function getHeaderConfig(pathname: string): DashboardHeaderConfig {
  if (pathname === ROUTES.dashboard) {
    return {
      title: 'Overview',
      subtitle: 'High-level overview of indexed programmes',
      actionsVariant: 'dashboard',
    };
  }

  if (pathname.startsWith(ROUTES.projects)) {
    return {
      title: 'Projects',
      subtitle: 'Search and compare programmes from multiple sources',
      actionsVariant: 'projects',
    };
  }

  if (pathname.startsWith(ROUTES.sources)) {
    return {
      title: 'Sources',
      subtitle: 'Monitor extraction health and last run status',
      actionsVariant: 'sources',
    };
  }

  return {
    title: 'DC Project Explorer',
    subtitle: 'Unified view of programmes from multiple sources',
    actionsVariant: 'none',
  };
}

export const DC_REFRESH_EVENT = 'dc-dashboard-refresh';
export const DC_EXPORT_XLSX_EVENT = 'dc-export-xlsx';
export const DC_EXPORT_CSV_EVENT = 'dc-export-csv';

type DCEventName =
  | typeof DC_REFRESH_EVENT
  | typeof DC_EXPORT_XLSX_EVENT
  | typeof DC_EXPORT_CSV_EVENT;

export function dispatchDCEvent(name: DCEventName) {
  window.dispatchEvent(new CustomEvent(name));
}
